import React, { useState, useContext, useEffect } from 'react';
import styled from 'styled-components';
import Select from 'admin/components/atoms/Select';
import { AppContext } from 'admin/components/App';

const MoneySelector = ({ onChangeMoney, designatedMoney, enableMemberMoneys = false, ...rest }) => {
  const ctx = useContext(AppContext);
  const [moneyOptions, setMoneyOptions] = useState([]);
  const [selectedMoneyOption, setSelectedMoneyOption] = useState();

  useEffect(() => {
    const selectableMoneys = (user) => {
      if (user.isServiceUser()) {
        return user.privateMoneys;
      }
      if (enableMemberMoneys) {
        return user.moneys();
      }
      return user.issuedMoneys();
    };
    const moneys = selectableMoneys(ctx.user);
    const ops = moneys.map((m) => ({ label: m.name, value: m }));
    setMoneyOptions(ops);
    if (ops.length > 0) {
      setSelectedMoneyOption(ops[0]);
    }
  }, [ctx]);

  useEffect(() => {
    if (selectedMoneyOption) {
      onChangeMoney(selectedMoneyOption.value);
    }
  }, [selectedMoneyOption]);

  useEffect(() => {
    if (designatedMoney) {
      const ops = [{ label: designatedMoney.name, value: designatedMoney }];
      setMoneyOptions(ops);
      setSelectedMoneyOption(ops[0]);
    }
  }, [designatedMoney]);

  return (
    <>
      <Select
        options={moneyOptions}
        value={selectedMoneyOption}
        onChange={setSelectedMoneyOption}
        placeholder="マネーを選択して下さい"
        isDisabled={designatedMoney !== undefined}
        {...rest}
      />
    </>
  );
};

export default styled(MoneySelector)``;
